import { render } from "./PrivacyRightsView.vue?vue&type=template&id=12f427f6&scoped=true"
import script from "./PrivacyRightsView.vue?vue&type=script&lang=js"
export * from "./PrivacyRightsView.vue?vue&type=script&lang=js"

import "./PrivacyRightsView.vue?vue&type=style&index=0&id=12f427f6&scoped=true&lang=css"

import exportComponent from "/builds/pazzei/pazzei-landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f427f6"]])

export default __exports__